// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Represents the different log levels.
 * The higher the number the more restrictive the levels are.
 */
export enum LogLevel
{
  All = 0,
  Debug = 1,
  Information = 2,
  Warning = 3,
  Error = 4,
  Silent = 5
}